import { NodeExecutionLogItem } from '../api/getNodeExecutions';

export interface NodeExecutionSpend {
  totalTokens: number;
  runCount: number;
}

export function sumNodeExecutionSpend(
  items: NodeExecutionLogItem[],
): NodeExecutionSpend {
  const withTokens = items.filter(
    (item) => typeof item.usedTokens === 'number' && !item.isError,
  );
  const totalTokens = withTokens.reduce(
    (sum, item) => sum + (item.usedTokens ?? 0),
    0,
  );
  return {
    totalTokens: Math.round(totalTokens * 1000) / 1000,
    runCount: withTokens.length,
  };
}
